module.exports = {"320402001":"雕庄街道","320402002":"青龙街道","320402003":"茶山街道","320402004":"红梅街道","320402005":"天宁街道","320402006":"兰陵街道","320402109":"郑陆镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320402.json
// module id = 859
// module chunks = 0